import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';

import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import { BlackHeading, Black, LogeButtonSlim } from '../GeneralStyle'
import { ProfileBox } from './ProfileStyle'
import HotelCard from './HotelCard'

import Parse from 'parse'

class Hotels extends Component {

  constructor(props) {
    super(props)

    this.state = {
      hotels: []
    }
  }

  componentDidMount = async () => {
    // this.props.onRef(this)

    const query = new Parse.Query("Hotels");
    const hotels = await query.descending("order").find()

    hotels.forEach(hotel => {

      let { createdAt, updatedAt, ...data} = hotel.attributes

      // data.course = {
      //   courseName: "Golfclub Schloss Schönborn"
      // }

      data.id = hotel.id

      this.setState({hotels: [...this.state.hotels, data]})
    });
  }

  render() {

    const { uid } = this.props.match ? this.props.match.params : {}
    const { inline } = this.props
    let { hotels } = this.state

    const highlighted = hotels.find(hotel => hotel.id == uid)
    hotels = hotels.filter(hotel => hotel.id !== uid)

    return (
      <div style={{ maxWidth: 1400 }} id="hotels">

        { highlighted &&
          <ProfileBox style={{ padding: 5 }}>
            <HotelCard hotel={highlighted}></HotelCard>
          </ProfileBox>
        }

        <ProfileBox style={{ padding: 5, margin: inline ? 0 : "" }}>
          <BlackHeading style={{ fontSize: "200%", margin: 25, textAlign: "left", marginBottom: 0}}>{ highlighted ? "Weitere" : "Unsere" } Partner Hotels</BlackHeading>

        {
          hotels.map(hotel =>
            <HotelCard hotel={hotel}></HotelCard>
          )
        }

        </ProfileBox>

        { !inline &&
          <div style={{width: "100%", height: "45px"}}></div>
        }
      </div>
    )
  }
}
export default Hotels;



// WEBPACK FOOTER //
// /src/components/internal/Hotels.js